import { createRouter, createWebHistory } from 'vue-router'
import { pinia } from '@/pinia'
import routes from './routes'

const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,
  history: createWebHistory('/'),
})

router.beforeEach(async (to) => {
  const { useAuthStore } = await import('src/stores/AuthStore')
  const authStore = useAuthStore(pinia)

  if (!authStore.isInitialized) {
    await authStore.init()
  }

  const isAuth = authStore.isAuthenticated
  const isLoginRoute = to.path === '/login'

  if (!isAuth && !isLoginRoute) return '/login'
  if (isAuth && isLoginRoute) return '/'

  // Ensure user details are loaded for authenticated users
  if (isAuth && authStore.user == null) {
    await authStore.getUserDetails()
  }

  // Redirect to profile onboarding if no exam preferences set
  const skipOnboarding = ['/profile', '/login'].includes(to.path)
  if (isAuth && !skipOnboarding && authStore.user && !authStore.user.exams) {
    return '/profile?onboarding=true'
  }

  return true
})

export default router
